/**
 * QR codes as inline SVG, generated locally with `uqr` (no network, no
 * canvas). Dark modules in deep fir green on cream so it fits the page and
 * still scans: contrast is far above what scanners need.
 */
import { encode } from 'uqr';

export function qrSvg(text: string, options: { label?: string } = {}): string {
  const { data, size } = encode(text, { ecc: 'M', border: 2 });
  let path = '';
  data.forEach((row, y) => {
    row.forEach((dark, x) => {
      if (dark) path += `M${String(x)} ${String(y)}h1v1h-1z`;
    });
  });
  const label = options.label ?? text;
  return `<svg class="qr" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${String(size)} ${String(size)}" role="img" aria-label="QR-Code: ${label.replace(/"/g, '&quot;')}" shape-rendering="crispEdges"><rect width="${String(size)}" height="${String(size)}" fill="#fffdf5"/><path d="${path}" fill="#1f3b2d"/></svg>`;
}
